<template>
  <div :style="$vuetify.breakpoint.mdAndUp ? 'height:100%;' : ''" class="desktop-flex-column">
    <v-card class=" pb-3 histories-type">
      <v-card-title>
        {{ $t(`label.history`) }}
      </v-card-title>
      <v-card-subtitle class="ht-subtitle">
        {{ $t(`label.historyType`) }}
      </v-card-subtitle>
      <v-row no-gutters justify="end" class="px-10 pb-3 hidden-sm-and-down">
        <v-col class="" cols="12">
          <div class="hl-type-header">
            <v-btn class="player-history-tab" v-for="(n, k) in historiesType" depressed @click="onChangeTab(n.page, n.subTabName)" :color="localRoute.name == n.page ? 'buttonPrimary no-opacity' : ''">
              {{ $t(`label.${n.name}`) }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <!--    <hr style="" />-->
    <!--    <v-divider class="ml-3"></v-divider>-->
    <router-view stlye="padding-top:12px"></router-view>
    <!--    <div class="" :style="$vuetify.breakpoint.mdAndUp ? 'height:100%;' : ''">-->
    <!--      -->
    <!--    </div>-->
  </div>
</template>

<script>
import { ROUTE_NAME } from '@/constants/route.constants'

export default {
  name: 'historiesLayout',
  // data: function() {
  //   return {
  //     localRoute: this.$route,
  //     historiesType: [
  //       {
  //         name: 'Bet History',
  //         page: ROUTE_NAME.HISTORIESTAB_TRANSACTION,
  //         id: 1
  //       },
  //       {
  //         name: 'Turnover History',
  //         page: ROUTE_NAME.HISTORIESTAB_TURNOVER,
  //         id: 2
  //       }
  //     ]
  //   }
  // },
  created() {
    console.log('here is historiesLayout created', this.$route.path)
    this.localRoute = this.$route
  },
  data: () => ({
    selectedTab: 'DEPOSIT',
    routeName: ROUTE_NAME,
    localRoute: {},
    historiesType: [
      {
        name: 'depositHistory',
        page: ROUTE_NAME.HISTORIESTAB_TRANSACTION,
        subTabName: 'DEPOSIT',
        id: 1
      },
      {
        name: 'withdrawalHistory',
        page: ROUTE_NAME.HISTORYTAB_WITHDRAWAL,
        subTabName: 'WITHDRAWAL',
        id: 2
      },
      {
        name: 'transferHistory',
        page: ROUTE_NAME.HISTORYTAB_TRANSFER,
        subTabName: 'TRANSFER',
        id: 3
      },
      {
        name: 'bonusHistory',
        page: ROUTE_NAME.HISTORYTAB_BONUS,
        subTabName: 'BONUS',
        id: 4
      },

      {
        name: 'turnoverHistory',
        page: ROUTE_NAME.HISTORIESTAB_TURNOVER,
        subTabName: 'TURNOVERHISTORY',
        id: 5
      },
      {
        name: 'betHistory',
        page: ROUTE_NAME.HISTORYTAB_BET,
        subTabName: 'BETHISTORY',
        id: 6
      },
      {
        name: 'redeemHistory',
        page: ROUTE_NAME.HISTORYTAB_REDEEM,
        subTabName: 'REDEMPTION',
        id: 7
      },
      {
        name: 'freeSpinHistory',
        page: ROUTE_NAME.HISTORYTAB_FREESPIN,
        subTabName: 'FREESPIN',
        id: 8
      }
    ]
  }),
  watch: {
    $route() {
      console.log('$route watcher')
      this.localRoute = this.$route
    }
  },
  methods: {
    onChangeTab(_routeName, _subTabName) {
      this.selectedTab = _subTabName
      this.$router.push({ name: _routeName, params: { lang: this.localRoute.params.lang }, props: { tabSelected: _subTabName } })
    }
  }
}
</script>

<style lang="scss">
.desktop-flex-column {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-wrap: nowrap;
}
.hl-type-header {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 5px;
}
.histories-type {
  border-radius: 10px 10px 0 0 !important;
  //border-bottom: 1px solid #d3d3d3;
  border-bottom-color: rgba(236, 236, 236, 1) !important;
  /* border-bottom: 1px solid; */
  border-bottom-width: medium;
  border-bottom-style: solid;
  box-shadow: unset !important;
  .ht-subtitle {
    padding-top: 16px !important;
  }

  @media (min-width: 959px) {
    margin-left: 12px !important;
  }
}

.player-history-tab {
  opacity: 0.6;
  width: 125px;
  margin-right: 15px;
  padding: 10px;
  background-color: #fff;
  text-transform: capitalize;
  border-radius: 12px;
  @media (min-width: 959px) {
    height: 40px !important;
  }
  //@media (min-width: 1200px) and (max-width: 3999px) {
  //  width: 150px;
  //}
}

.no-opacity {
  opacity: 1 !important;
}
</style>
